import React from 'react';
import PublicPageShell from '../components/PublicPageShell';
import Hero from '../components/Hero';
import HomeInternalLinks from '../components/HomeInternalLinks';
import IndustriesPreview from '../components/IndustriesPreview';
import FounderIntroduction from '../components/FounderIntroduction';
import HowItWorks from '../components/HowItWorks';
import Pricing from '../components/Pricing';
import Modules from '../components/Modules';
import MonthlyPlans from '../components/MonthlyPlans';
import SalesQuote from '../components/SalesQuote';
import ContactCTA from '../components/ContactCTA';

const Home = () => {
  return (
    <PublicPageShell>
      <Hero />
      <HomeInternalLinks />
      <IndustriesPreview />
      <FounderIntroduction />
      <HowItWorks />
      <Pricing />
      <Modules />
      <MonthlyPlans />
      <SalesQuote />
      <ContactCTA />
    </PublicPageShell>
  );
};

export default Home;
